// Helpers puros de las herramientas de dibujo (sin estado, sin motor).
import { DASH_PATTERNS } from '../data/tool-options'

// Tipo de trazo ('solid' | 'dashed' | 'dotted') → array de dash de Konva.
export function dashTypeToArray(type) {
  return DASH_PATTERNS[type] || []
}

// Array de dash → tipo de trazo (inverso aproximado de DASH_PATTERNS).
export function dashArrayToType(dash) {
  if (!dash || dash.length === 0) return 'solid'
  return dash[0] >= 4 ? 'dashed' : 'dotted'
}
